/**
 * 重稿比对页面控制器
 */
angular
    .module('editingCenterServiceModule')
    .controller('repeatCompareCtrl', ['$scope', 'trsHttpService', '$state', '$q', '$timeout', function($scope, trsHttpService, $state, $q, $timeout) {
        initStatus();
        initData();

        /**
         * [initstatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.originalDoc = {};
            $scope.originDoc = {};
            $scope.repeatDosList = [];
            $scope.currentRepeatDoc = {};
            $scope.status = {
                isShowRepeatList: false,
                isShowResult: false
            };
        }

        /**
         * [initData 初始化数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            getData();
        }

        /**
         * [getData 获取数据]
         *
         * @return  {[type]}  [return description]
         */
        function getData() {
            let params = {
                'serviceid': 'mlf_paper',
                'methodname': 'getPaiChongDetail',
                'PubDate': $state.params.pubdate,
                'MetaDataId': $state.params.id
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                if (data.RESULT.DOC && data.RESULT.XILAN.length) {
                    $scope.originDoc = data.RESULT.DOC;
                    $scope.loadingPromise = loadDiffMatchPatch().then(() => {
                        $scope.originalDoc = angular.copy(data.RESULT.DOC);
                        $scope.currentRepeatDoc = data.RESULT.XILAN[0];
                        $scope.repeatDosList = data.RESULT.XILAN;
                        $scope.loadingPromise = $timeout(function(){
                            compareDoc();
                        }, 1000);
                    });
                }
            });
        }

        /**
         * [compareDoc 对比内容]
         *
         * @param   {[type]}  originalHtml  [originalHtml description]
         * @param   {[type]}  repeatHtml    [repeatHtml description]
         *
         * @return  {[type]}                [return description]
         */
        function compareDoc() {
            let originalDocContent = document.getElementById('originalDocContent').innerHTML.replace(/<\/p>/gi,'</p>\n');
            let repeatDocContent = document.getElementById('repeatDocContent').innerHTML.replace(/<\/p>/gi,'</p>\n');

            let diffs = diffLineMode(originalDocContent, repeatDocContent);
            let newHtml1 = '';
            let newHtml2 = '';
            for (let i = 0; i < diffs.length; i++) {
                let diff = diffs[i];
                if (diff[0] === -1) {
                    newHtml1 += diff[1];
                } else if (diff[0] === 0) {
                    // newHtml1 += diff[1].replace(/(<[^\/]*>)([^<]*)(<\/.*$)/gi, '$1<span style="color: #12c1fa !important;">$2</span>$3');
                    // newHtml2 += diff[1].replace(/(<[^\/]*>)([^<]*)(<\/.*$)/gi, '$1<span style="color: #12c1fa !important;">$2</span>$3');
                    newHtml1 += `<span style="color: red !important;">${diff[1]}</span>`;
                    newHtml2 += `<span style="color: red !important;">${diff[1]}</span>`;
                } else {
                    newHtml2 += diff[1];
                }
            }
            // return [newHtml1, newHtml2];
            document.getElementById('originalDocContent').innerHTML = newHtml1;
            document.getElementById('repeatDocContent').innerHTML = newHtml2;
            $scope.status.isShowResult = true;
        }

        /**
         * [diffLineMode 按行对比]
         *
         * @param   {[type]}  text1  [text1 description]
         * @param   {[type]}  text2  [text2 description]
         *
         * @return  {[type]}         [return description]
         */
        function diffLineMode(text1, text2) {
            var dmp = new diff_match_patch();
            var a = dmp.diff_linesToChars_(text1, text2);
            var lineText1 = a.chars1;
            var lineText2 = a.chars2;
            var lineArray = a.lineArray;
            var diffs = dmp.diff_main(lineText1, lineText2, false);
            dmp.diff_charsToLines_(diffs, lineArray);
            return diffs;
        }

        /**
         * [loadBigFace description] 加载谷歌对比算法源码
         * @return {[type]} [description]
         */
        function loadDiffMatchPatch() {
            var deffer = $q.defer();
            LazyLoad.js(['./lib/bigface/diff_match_patch.js?v9.0'], function() {
                deffer.resolve();
            });
            return deffer.promise;
        }

        $scope.toggleSelectList = function() {
            $scope.status.isShowRepeatList = !$scope.status.isShowRepeatList;
        };

        $scope.switchDoc = function(item) {
            $scope.status.isShowRepeatList = false;
            $scope.status.isShowResult = false;
            if (item === $scope.currentRepeatDoc) {
                return;
            }
            $scope.originalDoc = angular.copy($scope.originDoc);
            $scope.currentRepeatDoc = angular.copy(item);
            $scope.loadingPromise = $timeout(function(){
                compareDoc();
            }, 1000);
        };
    }]);
